export default __webpack_public_path__ + "static/media/DiscordBlackIcon.5bfafb89.svg";